import { Box, Chip, Paper, Typography } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import React from 'react';
import { MQTT_TYPE_COLOR } from '../constants';
import useStyles from '../styles';

// Cột 3: Bảng tin MQTT realtime
const MqttLogPanel = ({ socketConnected, messages }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.card}>
      <Box className={classes.mqttHeader}>
        <Typography className={classes.plainTitle}>Kết nối MQTT</Typography>
        <Box className={socketConnected ? classes.connPillOn : classes.connPillOff}>
          <FiberManualRecordIcon style={{ fontSize: 10 }} />
          <Typography variant="caption" style={{ marginLeft: 4, fontWeight: 600 }}>
            {socketConnected ? 'Đã kết nối' : 'Mất kết nối'}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.logBox}>
        {messages.length === 0 && (
          <Typography variant="caption" style={{ color: '#8a8a8a' }}>
            Chưa có bản tin nào
          </Typography>
        )}
        {messages.map(msg => (
          <Box
            key={msg._id}
            className={classes.logItem}
            style={{ borderLeftColor: MQTT_TYPE_COLOR[msg.type] || '#666' }}
          >
            <Box className={classes.logItemHeader}>
              <Chip
                size="small"
                label={msg.type}
                style={{
                  backgroundColor: MQTT_TYPE_COLOR[msg.type] || '#666',
                  color: '#fff',
                  height: 18,
                  fontSize: 10
                }}
              />
              <Typography variant="caption" style={{ marginLeft: 6, color: '#8a8a8a' }}>
                {moment(msg.ts).format('HH:mm:ss')}
              </Typography>
              {typeof msg._id === 'string' && msg._id.startsWith('sent-') && (
                <Typography
                  variant="caption"
                  style={{ marginLeft: 6, color: '#8a8a8a', fontStyle: 'italic' }}
                >
                  (đã gửi)
                </Typography>
              )}
            </Box>
            <Typography className={classes.logPayload}>
              {typeof msg.payload === 'string' ? msg.payload : JSON.stringify(msg.payload)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default MqttLogPanel;
